export const LOAD_AREA = "LOAD_AREA";
export const ADD_AREA = "ADD_AREA";
export const UPDATE_AREA = "UPDATE_AREA";
export const DELETE_AREA = "DELETE_AREA";
